/* eslint-disable arrow-body-style */
import React from 'react';

import { Button } from '@abyss/web/ui/Button';
import { riskScoresId } from '../../types';
import {
  riskScoresFilterPanelsApi,
  useRiskScoreFilterPanelStore,
} from '../../mothership/riskScoresFilterPanel.state';

export const SearchButton = () => {
  const testId = `${riskScoresId}SearchBtn`;
  const enabled = useRiskScoreFilterPanelStore(
    (state) => state.searchBtnEnabled
  );
  const { submit } = riskScoresFilterPanelsApi;

  return (
    <Button
      data-testid={testId}
      data-cy={testId}
      id="filterPanelSearchBtn"
      variant="solid"
      disabled={!enabled}
      onClick={submit}
    >
      Search
    </Button>
  );
};
